import { jsx } from "react/jsx-runtime";
import { MarketingTypography } from "../../MarketingTypography/index.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
function determineColor(fallbackArray) {
  for (const color of fallbackArray) {
    if (color) {
      return color;
    }
  }
  return "";
}
function MarkdownGroup({
  content,
  primaryColor,
  isDisableLinks
}) {
  var _a, _b;
  const colorStyles = {
    color: determineColor([
      (_b = (_a = content.color) == null ? void 0 : _a.text_color) == null ? void 0 : _b.hex,
      primaryColor == null ? void 0 : primaryColor.hex
    ]) || void 0
  };
  let spacingStyles = {};
  if (content.select_text_type === "disclaimer") {
    spacingStyles = {
      padding: "8px 0"
    };
  } else {
    spacingStyles = {
      marginBottom: "16px"
    };
  }
  return /* @__PURE__ */ jsx(CostcoBox, { sx: spacingStyles, children: /* @__PURE__ */ jsx(
    MarketingTypography,
    {
      component: content.select_semantics_type,
      id: `bulletdetailcard_markdown_${content.select_text_type}`,
      isMarkdown: true,
      sx: colorStyles,
      variant: content.select_text_type,
      isDisableLinks,
      children: content.markdown_text
    }
  ) });
}
export {
  MarkdownGroup
};
